import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../components/Header";

function Confirmation() {
  const { id } = useParams();

  const [reservation, setReservation] = useState(null);

  useEffect(() => {
    const fetchReservation = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/reservation/${id}`,
          { withCredentials: true }
        );
        setReservation(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchReservation();
  }, [id]);

  return (
    <>
      <Header />

      {/* 🔥 SPACING HEADER */}
      <div className="pt-28 bg-gray-50 min-h-screen flex items-center justify-center">

  <div className="w-full px-4">

    <div className="bg-white rounded-2xl shadow-sm border p-8 max-w-2xl mx-auto">

            {/* SUCCESS ICON */}
            <div className="flex flex-col items-center text-center">

              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center text-green-600 text-3xl mb-4">
                ✓
              </div>

              <h1 className="text-2xl font-semibold text-gray-900">
                Réservation confirmée
              </h1>

              <p className="text-gray-500 mt-2 text-sm">
                Un email de confirmation vous a été envoyé 📩
              </p>

            </div>

            {/* INFOS */}
            {reservation && (
              <div className="mt-8 border-t pt-6 space-y-4">

                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Référence</span>
                  <span className="font-medium">{reservation.reservationId}</span>
                </div>

                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Chambre</span>
                  <span className="font-medium">{reservation.roomTitle}</span>
                </div>

                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Dates</span>
                  <span className="font-medium">
                    {reservation.checkInDate} → {reservation.checkOutDate}
                  </span>
                </div>

                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Total</span>
                  <span className="font-semibold text-gray-900">
                    {reservation.totalPrice}€
                  </span>
                </div>

              </div>
            )}

            {/* CTA */}
            <div className="mt-8 flex justify-center gap-4">

              <a
                href="/"
                className="
                  px-5 py-2.5 rounded-lg text-sm font-medium
                  bg-gray-100 text-gray-700
                  hover:bg-gray-200 transition
                "
              >
                Retour à l'accueil
              </a>

              <a
                href="/my-reservations"
                className="
                  px-5 py-2.5 rounded-lg text-sm font-medium
                  bg-[#3A9D23] text-white
                  hover:bg-[#33891E] transition
                "
              >
                Voir mes réservations
              </a>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}

export default Confirmation;